/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IPharmacyHospitalAssociation {
  id?: string;
  associatedDate?: number;
  leavingDate?: number | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  openingTime?: string | null;
  closeTime?: string | null;
  internal?: boolean | null;
  createdDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  leftAssociation?: boolean | null;
  pharmacy?: IPharmacy;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IPharmacyHospitalAssociation> = {
  active: false,
  internal: false,
  leftAssociation: false,
};
